import axios from "axios";
import _ from "lodash";

const offers = {
  namespaced: true,
  state: {
    offers: [],
    categories: [],
    selected_category: 0,
    actives: {
      catOne: 0,
      catTwo: 0,
      catThree: 0,
      catFour: 0,
    },
    offer: {
      name: null,
      preview: null,
      images: null,
      button_text: null,
      description: null,
      action_type: 1,
      action: "",
      category: 1,
      profile_id: ["1"],
    },
  },
  mutations: {
    SET_OFFERS(state, offers) {
      state.offers = offers;
    },
    SET_ACTIVES(state, actives) {
      state.actives = actives;
    },
    ADD_OFFER(state, offer) {
      state.offers.push(offer);
    },
    DELETE_OFFER(state, offerId) {
      state.offers = state.offers.filter(function (item) {
        if (item.id == offerId) {
          if (item.is_active == true) {
            state.actives = state.actives - 1;
          }
        }
        return item.id != offerId;
      });
    },
    UPDATE_OFFER(state, offerId, offer) {
      var offerUpdated = state.offers.find((item) => {
        item.id == offerId;
      });
      state.offers[offerUpdated] = offer;
    },
    ADD_ACTIVES(state, cat) {
      state.actives[cat]++;
    },
    SUBSTRACT_ACTIVES(state, cat) {
      state.actives[cat]--;
    },
    PATCH_OFFER(state, offer) {
      var offerUpdated = state.offers.find((item) => {
        return item.id == offer.id;
      });
      state.offers[offerUpdated] = offer;
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_CATEGORY(state, category) {
      state.selected_category = category;
    },
    SET_OFFER_IMAGE(state, img) {
      state.offer.images = img;
      state.offer.name = state.offer.name ? state.offer.name + " " : "";
    },
    SET_OFFER_PREVIEW(state, img) {
      state.offer.preview = img;
      state.offer.name = state.offer.name ? state.offer.name + " " : "";
    },
    SET_OFFER_HEADER(state, title) {
      state.offer.name = title;
    },
    SET_OFFER_BTN_TEXT(state, btnText) {
      state.offer.button_text = btnText;
    },
    SET_OFFER_DESCRIPTION(state, desc) {
      state.offer.description = desc;
    },
    SET_OFFER_CATEGORY(state, cat) {
      state.offer.category = cat;
    },
    SET_EMPTY_DUMMY_OFFER(state) {
      state.offer = {
        name: null,
        preview: null,
        images: null,
        button_text: null,
        description: null,
        action_type: 1,
        action: "",
        category: 1,
        profile_id: ["1"],
      };
    },
    SET_SELECTED_OFFER(state, offer) {
      state.offer = offer;
    },
  },
  actions: {
    offerRequest({ commit, rootState }, store_id) {
      return new Promise((resolve, reject) => {
        var offer_url = "";
        if (store_id == "999999") {
          offer_url = process.env.VUE_APP_CORE_HOST + "/api/offer/?format=json";
        } else {
          offer_url =
            process.env.VUE_APP_CORE_HOST +
            "/api/offer/?store_id=" +
            store_id +
            "&format=json";
        }

        axios({
          method: "get",
          url: offer_url,
          headers: {
            Authorization: "Bearer " + rootState.auth.loggedIn.access,
          },
        })
          .then((response) => {
            let offer_actives = {
              catOne: 0,
              catTwo: 0,
              catThree: 0,
              catFour: 0,
            };

            _.each(response.data, (value) => {
              if (value.is_active == true) {
                if (value.category[0].id == 1) {
                  offer_actives.catOne++;
                } else if (value.category[0].id == 2) {
                  offer_actives.catTwo++;
                } else {
                  offer_actives.catThree++;
                }
              }
            }); // TODO revisar codigo de ofertas activadas
            commit("SET_ACTIVES", offer_actives);
            commit("SET_OFFERS", response.data);
            resolve({ offers: true });
          })
          .catch((err) => {
            console.log(err);
            reject({ offers: false });
          });
      });
    },
    addOffer({ commit, rootState }, newOffer) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_CORE_HOST + "/api/offer/",
          headers: {
            Authorization: "Bearer " + rootState.auth.loggedIn.access,
          },
          data: newOffer,
        })
          .then((response) => {
            commit("ADD_OFFER", response.data);
            resolve(JSON.stringify(response.data));
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    deleteOffer({ commit, rootState }, offerId) {
      return new Promise((resolve, reject) => {
        axios({
          method: "delete",
          url:
            process.env.VUE_APP_CORE_HOST +
            "/api/offer/delete/" +
            offerId +
            "/",
          headers: {
            Authorization: "Bearer " + rootState.auth.loggedIn.access,
          },
        })
          .then((response) => {
            commit("DELETE_OFFER", offerId);
            resolve(JSON.stringify(response.data));
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    /*
        action para actualizar información de una oferta
        */
    updateOffer({ commit, rootState }, offer) {
      return new Promise((resolve, reject) => {
        axios({
          method: "patch",
          url: process.env.VUE_APP_CORE_HOST + "/api/offer/" + offer.id + "/",
          headers: {
            Authorization: "Bearer " + rootState.auth.loggedIn.access,
          },
          data: offer.form,
        })
          .then((response) => {
            commit("UPDATE_OFFER", response.data.id, response.data);
            resolve(JSON.stringify(response.data));
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    updateOrderOffers({ commit, rootState }, offers) {
      return new Promise((resolve, reject) => {
        axios({
          method: "patch",
          url: process.env.VUE_APP_CORE_HOST + "/api/offer/order",
          headers: {
            Authorization: "Bearer " + rootState.auth.loggedIn.access,
          },
          data: offers,
        })
          .then((response) => {
            commit("UPDATE_ORDER_OFFERS", response.data);
            resolve(JSON.stringify(response.data));
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    updateActiveOffer(
      { state, commit, rootState },
      { offer_id, is_active, cat_id, profile_id }
    ) {
      let cat = "";
      if (cat_id == 1) {
        cat = "catOne";
      } else if (cat_id == 2) {
        cat = "catTwo";
      } else if (cat_id == 2) {
        cat = "catThree";
      } else {
        cat = "catFour";
      }

      if (state.actives[cat] < 13 && is_active == true) {
        return new Promise((resolve, reject) => {
          axios({
            method: "patch",
            url: process.env.VUE_APP_CORE_HOST + "/api/offer/" + offer_id + "/",
            headers: {
              Authorization: "Bearer " + rootState.auth.loggedIn.access,
            },
            data: { is_active: is_active, perfil_id: profile_id[0] },
          })
            .then((response) => {
              commit("UPDATE_OFFER", response.data.id, response.data);
              commit("ADD_ACTIVES", cat);
              resolve(JSON.stringify(response.data));
            })
            .catch((err) => {
              reject(err.response);
            });
        });
      } else if (is_active == false) {
        return new Promise((resolve, reject) => {
          axios({
            method: "patch",
            url: process.env.VUE_APP_CORE_HOST + "/api/offer/" + offer_id + "/",
            headers: {
              Authorization: "Bearer " + rootState.auth.loggedIn.access,
            },
            data: { is_active: is_active, perfil_id: profile_id[0] },
          })
            .then((response) => {
              commit("UPDATE_OFFER", response.data.id, response.data);
              commit("SUBSTRACT_ACTIVES", cat);
              resolve(JSON.stringify(response.data));
            })
            .catch((err) => {
              reject(err.response);
            });
        });
      } else {
        return false;
      }
    },
    publishOffer({ commit, rootState }, { id, publishData }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "patch",
          url: process.env.VUE_APP_CORE_HOST + "/api/offer/" + id + "/",
          headers: {
            Authorization: "Bearer " + rootState.auth.loggedIn.access,
          },
          data: publishData,
        })
          .then((response) => {
            commit("UPDATE_OFFER", response.data);
            resolve(JSON.stringify(response.data));
          })
          .catch((err) => {
            reject(err.response);
          });
      });
    },
    getCategories({ commit, rootState }) {
      axios({
        method: "get",
        url: process.env.VUE_APP_CORE_HOST + "/api/offer/category/",
        headers: {
          Authorization: "Bearer " + rootState.auth.loggedIn.access,
        },
      })
        .then((response) => {
          commit("SET_CATEGORIES", response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectCategory({ commit }, category) {
      commit("SET_CATEGORY", category);
    },
    setOfferImage({ commit }, img) {
      commit("SET_OFFER_IMAGE", img);
    },
    setOfferPreview({ commit }, img) {
      commit("SET_OFFER_PREVIEW", img);
    },
    setOfferHeader({ commit }, title) {
      commit("SET_OFFER_HEADER", title);
    },
    setOfferBtnText({ commit }, btnText) {
      commit("SET_OFFER_BTN_TEXT", btnText);
    },
    setOfferDescription({ commit }, desc) {
      commit("SET_OFFER_DESCRIPTION", desc);
    },
    setEmptyDummyOffer({ commit }) {
      commit("SET_EMPTY_DUMMY_OFFER");
    },
    setSelectedOffer({ commit }, selected) {
      commit("SET_SELECTED_OFFER", selected);
    },
    setOfferCategory({ commit }, cat) {
      commit("SET_OFFER_CATEGORY", cat);
    },
  },
  getters: {
    allOffers(state) {
      return state.offers;
    },
    getOffer(state) {
      return (id) => state.offers.filter((offer) => offer.id == id);
    },
    countOffers(state) {
      return state.offers.length;
    },
    getCategories(state) {
      return state.categories;
    },
    getSelectedCategory(state) {
      return state.selected_category;
    },
    getDummyOffer(state) {
      return state.offer;
    },
  },
};

export default {
  offers,
};
